"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_1 = require("../../common/i18n");
class CartProduct {
    constructor(id, priceOptionCode, ean, manufacturerSku, name, info, quantity, weight, axType, axCategory, brandName, currencyCode, priceVatPercent, priceEpr, priceEco, priceNet, priceListNet, priceCustomNet, priceCustomNetId, treadCode, size, diameter, fuelEfficiency, wetGripClass, noiseMeasurementValue, loadIndex, speedIndex, stockInfo) {
        this.id = id;
        this.priceOptionCode = priceOptionCode;
        this.ean = ean;
        this.manufacturerSku = manufacturerSku;
        this.name = name;
        this.info = info;
        this.quantity = quantity;
        this.weight = weight;
        this.axType = axType;
        this.axCategory = axCategory;
        this.brandName = brandName;
        this.currencyCode = currencyCode;
        this.priceVatPercent = priceVatPercent;
        this.priceEpr = priceEpr;
        this.priceEco = priceEco;
        this.priceNet = priceNet;
        this.priceListNet = priceListNet;
        this.priceCustomNet = priceCustomNet;
        this.priceCustomNetId = priceCustomNetId;
        this.treadCode = treadCode;
        this.size = size;
        this.diameter = diameter;
        this.fuelEfficiency = fuelEfficiency;
        this.wetGripClass = wetGripClass;
        this.noiseMeasurementValue = noiseMeasurementValue;
        this.loadIndex = loadIndex;
        this.speedIndex = speedIndex;
        this.stockInfo = stockInfo;
    }
    getProductName() {
        if (this.brandName !== '' && this.treadCode !== '') {
            return `<div class="font-bold">${this.brandName}</div>
                    <div class="font-normal">${this.treadCode}</div>
                    <div class="font-normal text-xs">${i18n_1.Translator.trans('sku', 'SKU', 'carts')}: ${CartProduct.cleanProductId(this.id)}</div>`;
        }
        return `<div class="font-bold">${this.name}</div>`;
    }
    getDetailsSize() {
        return `<div class="font-bold">${this.size}</div>
                <div class="font-normal">${this.loadIndex}${this.speedIndex}</div>
                <div class="font-normal">${this.info}</div>`;
    }
    // Megjelenítésnél szükséges, hogy csak a termék azonosító része jelenjen meg.
    // "101360@i8" -> "101360"
    static cleanProductId(id) {
        if (!id)
            return '';
        return String(id).split('@')[0];
    }
}
exports.default = CartProduct;
